import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Text } from "@core/index";
export default function HeroTitle({
  title,
  description,
  titleStyle,
  titleBackgroundStyle,
  buttonStyle,
  buttonLink,
  onClick,
}: {
  title: string;
  description?: string;
  titleStyle: string;
  titleBackgroundStyle: string;
  buttonStyle?: string;
  buttonLink?: string;
  onClick?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="relative flex flex-col gap-4 md:gap-0 md:flex-row items-center justify-between px-4 mb-4">
      <div className={`absolute inset-0 blur-xl ${titleBackgroundStyle}`}></div>
      <div>
        <h1
          className={`relative text-3xl font-extrabold tracking-tight bg-clip-text text-transparent ${titleStyle}`}
        >
          {title}
        </h1>
        {description && (
          <Text
            variant="p"
            status="subtle"
            size={"base"}
            className="relative mt-2 md:!text-lg leading-relaxed"
          >
            {description}
          </Text>
        )}
      </div>
      {buttonLink && (
        <Link
          to={buttonLink}
          onClick={onClick}
          className={`relative group inline-flex items-center justify-center px-6 py-3 text-sm font-medium transition-all duration-200 transform hover:scale-105 text-white rounded-full shadow-lg hover:shadow-xl ${buttonStyle}`}
        >
          <Plus
            size={18}
            className="mr-2 transition-transform group-hover:rotate-90"
          />
          <span>{t("common.create")}</span>
        </Link>
      )}
    </div>
  );
}
